import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SolarChartLinear from "../icons/SolarChartLinear";
import SolarSettingsLinear from "../icons/SolarSettingsLinear";
import SolarSiderbarLinear from "../icons/SolarSiderbarLinear";
import SideBarItemList from "./SideBarItemList";
import env from "../../utils/helpers/functions/env";
import MarketSideBarMenu from "../../plugins/Market/components/MarketSideBarMenu";
import SolarUserCircleOutline from "../icons/SolarUserCircleOutline";
import SolarUserOutline from "../icons/SolarUserOutline";
import SolarUserLinear from "../icons/SolarUserLinear.jsx";
import { useAuth } from "../../context/AuthContext.jsx";
 
const SideBarUl = ({setMobSideBarShow}) => {

    const { t } = useTranslation();
    const { auth } = useAuth();
    const location = useLocation();

    return ( 
        <ul className="pc-navbar d-block"
            onClick={(e)=>{
                
                if (e?.target?.classList?.contains('hide-sidebar'))
                    setMobSideBarShow(false);
            }}>
            <li className="pc-item pc-caption">
                <label>{t('SideBarUl.titleMainMenu')}</label>
            </li>
 
            <li className={`pc-item  ${location.pathname == '/dashboard' ? 'active' : ''}`} >
                <Link className="pc-link hide-sidebar"
                    to="/dashboard">
                    <span className="pc-micon">
                        
                        <SolarChartLinear/> 
                    </span>
                    <span className="pc-mtext">{t('SideBarUl.itemDashboard')}</span>
                </Link>
            </li>

            {(auth?.user?.admin != 0) && (<>
                <li className={`pc-item  ${location.pathname == '/users' ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/users">
                        <span className="pc-micon">
                            <SolarUserLinear/> 
                        </span>
                        <span className="pc-mtext">{t('SideBarUl.itemUsers')}</span>
                    </Link>
                </li>
    
                <li className={`pc-item  ${location.pathname == '/settings' ? 'active' : ''}`} >
                    <Link className="pc-link hide-sidebar"
                        to="/settings">
                        <span className="pc-micon">
                            <SolarSettingsLinear/> 
                        </span>
                        <span className="pc-mtext">{t('SideBarUl.itemSettings')}</span>
                    </Link>
                </li>  
            </>)}
 
            <SideBarItemList
                title={t('SideBarUl.itemContent')} 
                icon={(<SolarSiderbarLinear/>)}
                itemsList={[
                    {label:t('SideBarUl.itemPages'), to:'/pages', startsWith:'/pages'},
                    {label:t('SideBarUl.itemBlog'), to:'/blog', startsWith:'/blog'} 
                ]}/>

            
            {(env('REACT_APP_PLUGINS')==1) && (
            <li className="pc-item pc-caption">
                <label>{t('SideBarUl.titlePlugins')}</label>
            </li>)} 
 
            {(env('REACT_APP_MARKET')==1) && (<MarketSideBarMenu/>)}

        </ul>
    )
}

export default SideBarUl;